import { Button } from "antd";
import styled from "styled-components";
import { color } from "../../resources";

export const StyledButtonPrimary = styled(Button).attrs((_props) => ({
  type: "primary",
}))`
  background-color: ${color.btn_primary};
  min-width: 120px;
  border-radius: 120px;
  font-size: 14px;
  border-color: ${color.btn_primary};
  color: #ffffff;
  &:hover,
  &:focus {
    background-color: ${color.btn_primary}DD;
    border-color: ${color.btn_primary}DD;
  }
`;

export const StyledButtonSecondary = styled(Button).attrs((_props) => ({
  type: "secondary",
}))`
  background-color: none;
  min-width: 120px;
  border-radius: 120px;
  font-size: 14px;
  border-color: ${color.btn_primary};
  color: ${color.btn_primary};
  &:hover,
  &:focus {
    background-color: none;
    border-color: ${color.btn_primary}DD;
    color: ${color.btn_hover_primary}DD;
  }
`;

export const StyledButtonExportFile = styled(Button).attrs((_props) => ({
  type: "primary",
}))`
  background-color: ${color.orange_red};
  min-width: 120px;
  font-size: 14px;
  border-color: ${color.orange_red};
  color: ${color.white};
  &:hover,
  &:focus {
    background-color: none;
    border-color: ${color.orange_red}DD;
    color: ${color.orange_red}DD;
  }
`;
